const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');

module.exports = (s) => {
  return {
    channel_interface: {
      label: '媒体平台',
      type: 'select',
      hidden: true,
      props: {
        clearable: false,
        placeholder: '请选择媒体平台',
      },
      options: [
        {
          label: CHANNEL_INTERFACE_TEXT.GDT,
          value: CHANNEL_INTERFACE_TYPE.GDT,
        },
      ],
      value: CHANNEL_INTERFACE_TYPE.GDT,
    },
    advertiser_id: {
      label: '广告主账户',
      type: 'select',
      hidden: true,
      props: {
        filterable: true,
      },
      options: [],
      value: '',
      rules: { required: true, message: '请选择广告主账户', trigger: 'change' },
    },
    name: {
      label: '标签名称',
      type: 'input',
      hidden: true,
      value: '',
      rules: { required: true, message: '请选择标签名称', trigger: 'change' },
    },
    business_scenario: {
      label: '业务场景',
      type: 'select',
      props: {
        placeholder: '请选择业务场景',
      },
      options: [
        {
          label: '内容素材包类型',
          value: 'BUSINESS_SCENARIO_CONTENT',
        },
        {
          label: '投放素材包类型',
          value: 'BUSINESS_SCENARIO_DELIVERY',
        },
      ],
      value: '',
      rules: { required: true, trigger: ['change'], message: '请选择业务场景' },
    },
    material: {
      label: '素材',
      hidden: true,
      type: 'bind',
      value: {
        images: [],
        videos: [],
        tab: 'video',
      },
    },
  };
};
